<div class="MainContainer" style="background: #eee;padding-bottom: 2%;">

    <div class="StatsPageUpperContainer">
        <p class="StatsPageUpperTitle">
            {{'StatsPageUpperTitle' | translate}} {{this.parent.Company.Name}}
        </p>

        <div class="StatsPageUpperProgressPercentage" *ngIf="!this.parent.loading">
         {{'CompletedCompanyData' | translate}} {{this.parent.Company.Health?.DataLevelHealthStatus?.Percentage}}%
        </div>

        <div class="StatsPageUpperProgressContainer" style="width: 40%;" *ngIf="!this.parent.loading">
         <div [ngClass]="{'Critical': this.parent.Company?.Health?.DataLevelHealthStatus?.ID == -1, 'NeedsWork': this.parent.Company.Health?.DataLevelHealthStatus?.ID == 0, 'Medium': this.parent.Company.Health?.DataLevelHealthStatus?.ID == 1, 'Good': this.parent.Company.Health?.DataLevelHealthStatus?.ID == 2, 'VeryGood': this.parent.Company.Health?.DataLevelHealthStatus?.ID == 3, 'Complete': this.parent.Company.Health?.DataLevelHealthStatus?.ID == 4}" class="StatsPageUpperProgressBarUnit" *ngFor="let p of this.parent.Company.Health?.DataLevelHealthStatus?.PercentageArray;">
         </div>
        </div>

        <div class="StatsPageUpperProgressContainer" style="background: #fff;width: 60%;" *ngIf="!this.parent.loading">
        </div>

        <div class="StatsPageUpperContainerBody" *ngIf="!this.parent.loading">
          <div class="StatsPageCompanyError" *ngFor="let m of this.parent.Company.Health?.DataLevelHealthStatusMessages;">
            <a class="StatsPageCompanyErrorResolveButton" mat-button href="/dashboard/settings/mycompany" target="_blank">{{'Resolve'| translate}}</a>
            <span>{{m}}</span>
          </div>
        </div>
    </div>

       <div class="ChartContainer">
        
        <div class="ChartTitle" *ngIf="!loadingSalesChart">
            {{SalesChart.Title}}
            <mat-slide-toggle (change)="GetSalesCharts();" [(ngModel)]="SalesChart.DisplayOnlyInMainCurrency" class="OnlyInMainCurrencySlider">{{'OnlyMainCurrency' | translate}}</mat-slide-toggle>
        </div>

        <div class="ChartCommand">
            <mat-form-field class="ReceptionProductsColDropDown StatsControl" appearance="outline">
              <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
              <mat-select [compareWith]="compareFn" name="Administration" [(ngModel)]="SalesChartFilter.Period">
                <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="GetSalesCharts();this.SalesChartFilter.FromDate = null;this.SalesChartFilter.ToDate = null;">
                  {{a.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="StatsControl">
              <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
              <input matInput [matDatepicker]="dp" [formControl]="SalesChartFromDate" [(ngModel)]="SalesChartFilter.FromDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
              <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="StatsControl">
              <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
              <input matInput [matDatepicker]="dp1" [formControl]="SalesChartToDate" [(ngModel)]="SalesChartFilter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
              <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
              <mat-datepicker #dp1></mat-datepicker>
            </mat-form-field>
        </div>
    
        <div class="ChartTitleValue" *ngIf="!loadingSalesChart">
            <div *ngFor="let v of SalesChart.Values" style="margin-right: 20px;float: left;">
              <span class="ChartTitleInteger">
                {{v.Integer}}
            </span>
            <span class="ChartTitleDecimals">
                {{v.Decimals}}
            </span>
            </div>
            <button (click)="GetSalesCharts();" class="ChartRefreshButton" mat-raised-button color="primary"><i class="material-icons">refresh</i></button>
        </div>

        <div *ngIf="!loadingSalesChart" style="display: block;">
            <canvas baseChart
              [datasets]="SalesChart.ChartDataSets"
              [labels]="SalesChart.Labels"
              [options]="SalesChart.ChartOptions"
              [colors]="SalesChart.ChartColors"
              [legend]="SalesChart.lineChartLegend"
              [chartType]="SalesChart.lineChartType"
              [plugins]="SalesChart.lineChartPlugins">
            </canvas>
          </div>
   
          <mat-spinner class="smallSpinner" [diameter]="30" style="margin-top: 50px;" *ngIf="loadingSalesChart"></mat-spinner>
       </div>

       <div class="ChartContainer">

        <div class="ChartTitle">
          {{ClientsDebt.Title}}
          <mat-slide-toggle (change)="GetClientsDebt();" [(ngModel)]="ClientsDebt.DisplayOnlyInMainCurrency" class="OnlyInMainCurrencySlider">{{'OnlyMainCurrency' | translate}}</mat-slide-toggle>
        </div>

        <div class="ChartCommand">
          <mat-form-field class="ReceptionProductsColDropDown StatsControl" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select [compareWith]="compareFn" name="Administration" [(ngModel)]="ClientsDebtFilter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="GetClientsDebt();this.ClientsDebtFilter.FromDate = null;this.ClientsDebtFilter.ToDate = null;">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp5" [formControl]="ClientsDebtFromDate" [(ngModel)]="ClientsDebtFilter.FromDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp5"></mat-datepicker-toggle>
            <mat-datepicker #dp5></mat-datepicker>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp6" [formControl]="ClientsDebtToDate" [(ngModel)]="ClientsDebtFilter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp6"></mat-datepicker-toggle>
            <mat-datepicker #dp6></mat-datepicker>
          </mat-form-field>
      </div>

      <div class="ChartContainerBody">
        <div class="ClientsDebtRow" *ngFor="let c of ClientsDebt.ClientsDebt">
          <p>{{c.Partner.Name}}</p>
          <p style="width: 40%;text-align: right;padding-right: 3%;font-weight: bold;font-size: 14px;">{{c.SUM}} {{c.Currency.Name}}</p>
          <mat-progress-bar class="ClientsDebtProgressBar" mode="determinate" value="{{c.PercentageValue}}"></mat-progress-bar>
        </div>
      </div>

      <div class="ChartTitleValue">
        <button [disabled]="loadingClientsDebt" (click)="GetClientsDebt();" class="ChartRefreshButton" mat-raised-button color="primary"><i class="material-icons">refresh</i></button>
    </div>

       </div>

       <div class="ChartContainer">
        
        <div class="ChartTitle" *ngIf="!loadingVATChart">
            {{VATChart.Title}}
        </div>

        <div class="ChartCommand">
          <mat-form-field class="ReceptionProductsColDropDown StatsControl" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select [compareWith]="compareFn" name="Administration" [(ngModel)]="VATChartFilter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="GetVATChart();this.VATChartFilter.FromDate = null;this.VATChartFilter.ToDate = null;">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="VATChartFromDate" [(ngModel)]="VATChartFilter.FromDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp4" [formControl]="VATChartToDate" [(ngModel)]="VATChartFilter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
            <mat-datepicker #dp4></mat-datepicker>
          </mat-form-field>
      </div>
    
        <div class="ChartTitleValue" *ngIf="!loadingVATChart">
            <div *ngFor="let v of VATChart.Values" style="margin-right: 20px;float: left;">
              <span class="ChartTitleInteger">
                {{v.Integer}}
            </span>
            <span class="ChartTitleDecimals">
                {{v.Decimals}}
            </span>
            </div>
            <button (click)="GetVATChart();" class="ChartRefreshButton" mat-raised-button color="primary"><i class="material-icons">refresh</i></button>
        </div>

        <div *ngIf="!loadingVATChart" style="display: block;">
            <canvas baseChart
              [datasets]="VATChart.ChartDataSets"
              [labels]="VATChart.Labels"
              [options]="VATChart.ChartOptions"
              [colors]="VATChart.ChartColors"
              [legend]="VATChart.lineChartLegend"
              [chartType]="VATChart.lineChartType"
              [plugins]="VATChart.lineChartPlugins">
            </canvas>
          </div>
   
          <mat-spinner class="smallSpinner" [diameter]="30" style="margin-top: 50px;" *ngIf="loadingVATChart"></mat-spinner>
       </div>

       <div class="ChartContainer">
        
        <div class="ChartTitle" *ngIf="!loadingCCPChart">
            {{CCPChart.Title}}
            <mat-slide-toggle (change)="GetCCPChart();" [(ngModel)]="CCPChart.DisplayOnlyInMainCurrency" class="OnlyInMainCurrencySlider">{{'OnlyMainCurrency' | translate}}</mat-slide-toggle>
        </div>

        <div class="ChartCommand">
          <mat-form-field class="ReceptionProductsColDropDown StatsControl" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select [compareWith]="compareFn" name="Administration" [(ngModel)]="CCPChartFilter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="GetCCPChart();this.CCPChartFilter.FromDate = null;this.CCPChartFilter.ToDate = null;">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp5" [formControl]="CCPChartFromDate" [(ngModel)]="CCPChartFilter.FromDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp5"></mat-datepicker-toggle>
            <mat-datepicker #dp5></mat-datepicker>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp6" [formControl]="CCPChartToDate" [(ngModel)]="CCPChartFilter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp6"></mat-datepicker-toggle>
            <mat-datepicker #dp6></mat-datepicker>
          </mat-form-field>
      </div>
    
        <div class="ChartTitleValue" *ngIf="!loadingCCPChart">
            <div *ngFor="let v of CCPChart.Values" style="margin-right: 20px;float: left;">
              <span class="ChartTitleInteger">
                {{v.Integer}}
            </span>
            <span class="ChartTitleDecimals">
                {{v.Decimals}}
            </span>
            </div>
            <button (click)="GetCCPChart();" class="ChartRefreshButton" mat-raised-button color="primary"><i class="material-icons">refresh</i></button>
        </div>

        <div *ngIf="!loadingCCPChart" style="display: block;">
            <canvas baseChart
              [datasets]="CCPChart.ChartDataSets"
              [labels]="CCPChart.Labels"
              [options]="CCPChart.ChartOptions"
              [colors]="CCPChart.ChartColors"
              [legend]="CCPChart.lineChartLegend"
              [chartType]="CCPChart.lineChartType"
              [plugins]="CCPChart.lineChartPlugins">
            </canvas>
          </div>
   
          <mat-spinner class="smallSpinner" [diameter]="30" style="margin-top: 50px;" *ngIf="loadingCCPChart"></mat-spinner>
       </div>

       <div class="ChartContainer">

        <div class="ChartTitle">
          {{SuppliersDebt.Title}}
          <mat-slide-toggle (change)="GetSuppliersDebt();" [(ngModel)]="SuppliersDebt.DisplayOnlyInMainCurrency" class="OnlyInMainCurrencySlider">{{'OnlyMainCurrency' | translate}}</mat-slide-toggle>
        </div>

        <div class="ChartCommand">
          <mat-form-field class="ReceptionProductsColDropDown StatsControl" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select [compareWith]="compareFn" name="Administration" [(ngModel)]="SuppliersDebtFilter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="GetSuppliersDebt();this.SuppliersDebtFilter.FromDate = null;this.SuppliersDebtFilter.ToDate = null;">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp5" [formControl]="SuppliersDebtFromDate" [(ngModel)]="SuppliersDebtFilter.FromDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp5"></mat-datepicker-toggle>
            <mat-datepicker #dp5></mat-datepicker>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp6" [formControl]="SuppliersDebtToDate" [(ngModel)]="SuppliersDebtFilter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp6"></mat-datepicker-toggle>
            <mat-datepicker #dp6></mat-datepicker>
          </mat-form-field>
      </div>

      <div class="ChartContainerBody">
        <div class="ClientsDebtRow" *ngFor="let c of SuppliersDebt.ClientsDebt">
          <p>{{c.Partner.Name}}</p>
          <p style="width: 40%;text-align: right;padding-right: 3%;font-weight: bold;font-size: 14px;">{{c.SUM}} {{c.Currency.Name}}</p>
          <mat-progress-bar class="ClientsDebtProgressBar" mode="determinate" value="{{c.PercentageValue}}"></mat-progress-bar>
        </div>
      </div>

      <div class="ChartTitleValue">
        <button [disabled]="loadingClientsDebt" (click)="GetSuppliersDebt();" class="ChartRefreshButton" mat-raised-button color="primary"><i class="material-icons">refresh</i></button>
    </div>

       </div>

       <div class="ChartContainer">
        
        <div class="ChartTitle" *ngIf="!loadingVATChart">
            {{CreditDebit.Title}}
            <mat-slide-toggle (change)="GetCreditDebitChart();" [(ngModel)]="CreditDebit.DisplayOnlyInMainCurrency" class="OnlyInMainCurrencySlider">{{'OnlyMainCurrency' | translate}}</mat-slide-toggle>
        </div>

        <div class="ChartCommand">
          <mat-form-field class="ReceptionProductsColDropDown StatsControl" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select [compareWith]="compareFn" name="Administration" [(ngModel)]="CreditDebitChartFilter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="GetCreditDebitChart();this.CreditDebitChartFilter.FromDate = null;this.CreditDebitChartFilter.ToDate = null;">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="CreditDebitChartFromDate" [(ngModel)]="CreditDebitChartFilter.FromDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="StatsControl">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp4" [formControl]="CreditDebitChartToDate" [(ngModel)]="CreditDebitChartFilter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
            <mat-datepicker #dp4></mat-datepicker>
          </mat-form-field>
      </div>
    
        <div class="ChartTitleValue" *ngIf="!loadingCreditDebit">
            <div *ngFor="let v of CreditDebit.Values" style="margin-right: 20px;float: left;">
              <span class="ChartTitleInteger">
                {{v.Integer}}
            </span>
            <span class="ChartTitleDecimals">
                {{v.Decimals}}
            </span>
            </div>
            <button (click)="GetCreditDebitChart();" class="ChartRefreshButton" mat-raised-button color="primary"><i class="material-icons">refresh</i></button>
        </div>

        <div *ngIf="!loadingCreditDebit" style="display: block;">
            <canvas baseChart
              [datasets]="CreditDebit.ChartDataSets"
              [labels]="CreditDebit.Labels"
              [options]="CreditDebit.ChartOptions"
              [colors]="CreditDebit.ChartColors"
              [legend]="CreditDebit.lineChartLegend"
              [chartType]="CreditDebit.lineChartType"
              [plugins]="CreditDebit.lineChartPlugins">
            </canvas>
          </div>
   
          <mat-spinner class="smallSpinner" [diameter]="30" style="margin-top: 50px;" *ngIf="loadingCreditDebit"></mat-spinner>
       </div>
 </div>